import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';

import { ShortcutTypeGlobal } from '../../../../samwebDescription/samweb/shortcuts/shortcutTypeGlobal';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-keyboard-settings',
   templateUrl: './keyboard-settings.component.html',
   styleUrls: ['./keyboard-settings.component.scss'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class KeyboardSettingsComponent {
   @Select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.CCO_PERM_EDIT_CONFIG_KEY_CONF))
   public isFeatureEnabled$: Observable<boolean>;

   public searchValue$: Observable<string>;

   public searchIcon: IconDefinition = WellKnownIconsEnum.SEARCH.icon;

   public availableHotkeyTypes = this.getValues();

   private getValues(): ShortcutTypeGlobal[] {
      return _(ShortcutTypeGlobal.values())
         .orderBy((shortcut) => this.translateService.instant(shortcut.translationKey))
         .value();
   }

   constructor(private translateService: TranslateService) {}

   public handleFilterChange(query: string): void {
      this.searchValue$ = of(query);
      const normalizedQuery = query.toLowerCase();
      const filterExpression = (shortcut: ShortcutTypeGlobal) =>
         this.translateService.instant(shortcut.translationKey).toLowerCase().indexOf(normalizedQuery) !== -1;
      this.availableHotkeyTypes = this.getValues().filter(filterExpression);
   }
}
